import { render, staticRenderFns } from "./promozioni.html?vue&type=template&id=e3390d7e&scoped=true&"
import script from "./Promozioni.vue?vue&type=script&lang=js&"
export * from "./Promozioni.vue?vue&type=script&lang=js&"
import style0 from "./Promozioni.vue?vue&type=style&index=0&id=e3390d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3390d7e",
  null
  
)

export default component.exports